import { ILocationModel } from '@/services/api.service';

export class JobItemLocationModel {
  public name: string = '';
  public gid: string = '';
  public location?: ILocationModel = undefined;
  public isSelectStub: boolean = false;
  public isCreateNewStub: boolean = false;
}
